<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>Tax Status</h1>
      <v-row>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Code"
            :class="classPadding"
            v-model="taxStatus.taxCode"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="8" class="pb-0 mb-0">
          <v-text-field
            label="Description"
            :class="classPadding"
            v-model="taxStatus.taxDesc"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
          <v-text-field
            label="Exemption"
            :class="classPadding"
            v-model="taxStatus.exemption"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
          <v-select
            label="Tax Type"
            :class="classPadding"
            v-model="taxStatus.taxType"
            :items="taxType"
            item-value="value"
            item-text="text"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            color="success"
            :loading="isSaving"
            :class="classPadding"
            @click.stop="save"
            v-if="userAccess.add >= 1"
            >Save</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>
      <!-- <router-view /> -->
    </v-container>
    <v-dialog v-model="editDialog" width="700" persistent>
      <v-card>
        <v-card-title>
          <span>Edit</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
                <v-text-field
                  label="Code"
                  :class="classPadding"
                  v-model="editTaxStatus.taxCode"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="8" class="pb-0 mb-0">
                <v-text-field
                  label="Description"
                  :class="classPadding"
                  v-model="editTaxStatus.taxDesc"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
                <v-text-field
                  label="Exemption"
                  :class="classPadding"
                  v-model="editTaxStatus.exemption"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="4" md="3" class="pb-0 mb-0">
                <v-select
                  label="Tax Type"
                  :class="classPadding"
                  v-model="editTaxStatus.taxType"
                  :items="taxType"
                  item-value="value"
                  item-text="text"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.stop="editDialog = false">close</v-btn>
          <v-btn
            text
            @click.stop="update"
            color="success"
            :loading="isUpdating"
            v-if="userAccess.update >= 1"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import List from "./List";
import taxType from "../../../../enums/taxType";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/taxStatus";
export default {
  metaInfo: {
    title: "Tax Status",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    List
  },
  data: () => ({
    classPadding: "my-0 py-0",
    componentKey: 0,
    taxStatus: {},
    isSaving: false,
    editTaxStatus: {},
    editDialog: false,
    isUpdating: false,
    taxType
  }),
  methods: {
    save() {
      this.$axios
        .post(`${API_ENDPOINT}`, this.taxStatus)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    update() {
      this.isUpdating = true;
      this.$axios
        .put(`${API_ENDPOINT}`, this.editTaxStatus)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    reset() {
      this.taxStatus = {};
      this.forceRerender();
      this.editDialog = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    edit(item) {
      this.editTaxStatus = Object.assign({}, item);
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.taxCode}/${item.taxType}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    }
  },
  created() {
    this.getUserAccessRights("TaxStatus");
  }
};
</script>